import { OrderInstruction } from '../components/maps/BundleMap';

/**
 * Check if two OrderInstructions are the same location and thus should be combined for rendering
 */
export const isSameLocation = (
  a: OrderInstruction,
  b: OrderInstruction
): boolean => {
  return (
    a.order.recipientLatitude === b.order.recipientLatitude &&
    a.order.recipientLongitude === b.order.recipientLongitude
  );
};

/**
 * Combine two OrderInstructions for rendering as one
 *
 * Assumed to be in sequence in the same bundle.
 */
export function combineInstructions(
  aInstruction: OrderInstruction,
  bInstruction: OrderInstruction
): OrderInstruction {
  // TODO: Handle relevant differences that would otherwise be erased
  //       Relevant here would mean things that are rendered and can be different
  const a = aInstruction.order;
  const b = bInstruction.order;

  return {
    ...aInstruction,
    label: 'M',
    order: {
      ...a,
      id: concatIfNotIncludes(a.id, `${b.id} (${bInstruction.listNumber})`),
      openCourierDeviation: a.openCourierDeviation || b.openCourierDeviation,
      deviations: a.deviations.concat(b.deviations),
      pickupName: concatIfNotIncludes(a.pickupName, b.pickupName),
      pickupPhone: concatIfNotIncludes(a.pickupPhone, b.pickupPhone),
      // not handled, but rendered: deliverFrom, deliverUntil
    },
  };
}

export function concatIfNotIncludes(a: string, b: string): string {
  return a.includes(b) ? a : `${a}, ${b}`;
}
